import { IconButton, Tooltip } from '@mui/material';
import { Contract } from '@protos/product';
import { useUserContext } from '@shared/contexts/UserContextProvider';
import { checkIsOutliersAdmin } from '@shared/utils/permissions';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { useNavigate } from 'react-router-dom';

export const ProductContractsActionsCellRenderer = (props: ICellRendererParams<Contract>) => {
  const navigate = useNavigate();
  const user = useUserContext();

  return (
    <Tooltip title="View Contract Outliers">
      <IconButton
        onClick={() => navigate(`/admin/outliers/${props.data?.symbol}`)}
        style={{ padding: 0, marginBottom: 3 }}
        disabled={!checkIsOutliersAdmin(user)}
      >
        <i className="ri-pulse-fill" style={{ fontSize: '16px' }} />
      </IconButton>
    </Tooltip>
  );
};
